import { IValidationContext } from "./IValidationContext";
import { IValidationRule } from "./IValidationRule";
import { IValidationRuleSettings } from "./IValidationRuleSettings";
import { IValidationScope } from "./IValidationScope";
import { IValidationScopeBuilder } from "./IValidationScopeBuilder";
import { ValidationRule } from "./ValidationRule";
import { ValidationRuleController } from "./ValidationRuleController";
export class ValidationScope implements IValidationScope, IValidationScopeBuilder {
    name: string;
    rules: IValidationRule[] = [];
    constructor(name: string, ctx: () => IValidationContext) {
        this.name = name;
        this.contextAccessor = ctx;
    }
    contextAccessor = (): IValidationContext => {
        throw new Error("contextAccessor is undefined");
    };
    withRules = (settings: IValidationRuleSettings[]): IValidationScopeBuilder => this.withRulesWhen(null, settings);
    withRulesWhen = (whenCondition: () => boolean, settings: IValidationRuleSettings[]): IValidationScopeBuilder => {
        settings.forEach(setting => {
            setting.applicable = this.buildApplicable(whenCondition, setting.applicable);
            const rule = new ValidationRule(setting);
            const ruleController = this.checkAddController(rule);
            ruleController.rules.push(rule);
            this.rules.push(rule);
        });
        return this;
    };

    forEach = <T>(children: T[], callback: (child: T, scope?: IValidationScopeBuilder, idx?: number) => void): IValidationScopeBuilder => {
        let idx = 0;
        children.forEach(x => {
            callback(x, this, idx);
            idx++;
        });
        return this;
    };

    private readonly checkAddController = (rule: IValidationRule): ValidationRuleController => {
        let ruleController = this[rule.name] as ValidationRuleController;
        if (ruleController == null) {
            ruleController = new ValidationRuleController(rule.name, () => this);
            this[rule.name] = ruleController;
        }
        return ruleController;
    };
    private readonly buildApplicable = (whenCondition: () => boolean, applicable: (newVal: any, oldVal: any) => boolean): (newVal: any, oldVal: any) => boolean => {
        if (!applicable) {
            applicable = () => true;
        }
        if (!whenCondition) {
            return applicable;
        }
        return (newVal, oldVal) => {
            if (!whenCondition()) {
                return false;
            }
            return applicable(newVal, oldVal);
        };
    };
}
